import Avatar_2 from "../../../../../assets/images/xs/avatar2.jpg";
import Avatar_10 from "../../../../../assets/images/xs/avatar10.jpg";
import Avatar_1 from "../../../../../assets/images/xs/avatar1.jpg";
import Avatar_8 from "../../../../../assets/images/xs/avatar8.jpg";
import Avatar_3 from "../../../../../assets/images/xs/avatar3.jpg";
import Avatar_7 from "../../../../../assets/images/xs/avatar7.jpg";
import Avatar_9 from "../../../../../assets/images/xs/avatar9.jpg";
import Avatar_4 from "../../../../../assets/images/xs/avatar4.jpg";
import Avatar_6 from "../../../../../assets/images/xs/avatar6.jpg";
import Avatar_5 from "../../../../../assets/images/xs/avatar5.jpg";

export const UserColumns = [
    {
        Header: "Name",
        accessor: "name"
    },
    {
        Header: "Image",
        accessor: "image"
    },
    {
        Header: "Status",
        accessor: "status"
    },
    {
        Header: "Action",
        accessor: "action"
    },
]

export const UserData = [
    {
        id: 0,
        name: "Ava Walker",
        image: Avatar_2,
        status: "in Active",
    },
    {
        id: 2,
        name: "Christopher Harris",
        image: Avatar_10,
        status: "Active",
    },
    {
        id: 3,
        name: "Daniel Martinez",
        image: Avatar_1,
        status: "in Active",
    },
    {
        id: 4,
        name: "David Lee",
        image: Avatar_8,
        status: "in Active",
    },
    {
        id: 5,
        name: "Depo Pillo",
        image: Avatar_3,
        status: "in Active",
    },
    {
        id: 6,
        name: "Emily White",
        image: Avatar_7,
        status: "Active",
    },
    {
        id: 7,
        name: "Emma Taylor",
        image: Avatar_9,
        status: "in Active",
    },
    {
        id: 8,
        name: "James Anderson",
        image: Avatar_3,
        status: "Active",
    },
    {
        id: 9,
        name: "Jenny Dillow",
        image: Avatar_2,
        status: "in Active",
    },
    {
        id: 10,
        name: "jone",
        image: Avatar_1,
        status: "Active",
    },
    {
        id: 11,
        name: "Michael Smith",
        image: Avatar_4,
        status: "in Active",
    },
    {
        id: 12,
        name: "Olivia Clark",
        image: Avatar_1,
        status: "Active",
    },
    {
        id: 13,
        name: "Robert Brown",
        image: Avatar_6,
        status: "in Active",
    },
    {
        id: 14,
        name: "Sarah Johnson",
        image: Avatar_5,
        status: "Active",
    },
]